import { Po } from './po';

// A PO can be for a supplier purchase or a branch to branch transfer, both are shown in the same list.
export class PoSupplier extends Po {
    // TODO ADD SUPPLIER!!
    po_number: string;
    currency_id: number;
    currency_symbol: string;
    currency_code: string;
    currency_name: string;
    supplier_order_ref: string;
    ship_to: string;
    proforma_invoice_number: string;
    proforma_invoice_date: string;
    downpayment_amount: number;
    downpayment_date: string;
    final_invoice_number: string;
    final_invoice_date: string;
    total_amount: number;

    additional_cost: number;
    additional_details: string;
    total_qty_produced: number;
    
    balace_due: number; //Calculated at db
    credit_details: string;
    credit_amount: number;
    balance_paid_amount: number;
    payment_date: string;
    notes: string;
    forward_agent_detail: string;
    closing_date: string;
    sailing_date: string;
    transport_way: string; // AIR, LCL, FCL, LAND
    place_of_dispatch: string;
    currency: string;
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/pos/poSupplier.ts